/**
 * Alexandria CLI - Re-export from @a24z/alexandria-cli
 * 
 * This is a temporary wrapper that re-exports the Alexandria CLI
 * from the @a24z/alexandria-cli package.
 */

// Import and immediately execute the CLI from the external package
import '@a24z/alexandria-cli';